export const messages = {
  en: {
    myItemOutAuditHistoryOrders: {
      title: 'Item Out Audit History Orders',
      orderId: 'Order ID',
      orderType: 'Order Type',
      orderStatus: 'Order Status',
      applicant: 'Applicant',
      createTime: 'Create Time',
      operation: 'Operation',
      view: 'View',
      back: 'Back',
      refresh: 'Refresh'
    }
  },
  zh: {
    myItemOutAuditHistoryOrders: {
      title: '领用已办单',
      orderId: '订单号',
      orderType: '订单类型',
      orderStatus: '订单状态',
      applicant: '申请人',
      createTime: '创建时间',
      operation: '操作',
      view: '查看',
      back: '返回',
      refresh: '刷新'
    }
  }
}